import { IconButton } from '@saucelabs/ds-button';
import { IconChevronLeftFill, IconChevronRightFill } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import React from 'react';

import KeyBind from '../common/KeyBind';

export type DiffHeaderNavProps = {
  diffIds: string[];
  prevPage: () => void;
  nextPage: () => void;
  stepId: string;
}

export const DiffHeaderNav: React.FC<
  DiffHeaderNavProps
> = ({ diffIds, prevPage, nextPage, stepId }) => {
  const diffCount = diffIds.length;
  const currentIndex = diffIds.findIndex((id) => id === stepId);

  return (
    <div className="flex">
      <KeyBind
        char="ArrowLeft"
        displayChar="←"
        func={prevPage}
        label="Previous Snapshot"
      >
        <IconButton
          aria-label="Previous Snapshot"
          icon={<IconChevronLeftFill />}
          onPress={prevPage}
          variant="text"
        />
      </KeyBind>
      <Typography
        className="text-medium-emphasis text-base flex items-center px-1 tracking-wider font-normal"
        variant="body-large"
      >
        {currentIndex + 1}
        /
        {diffCount}
      </Typography>
      <KeyBind
        char="ArrowRight"
        displayChar="→"
        func={nextPage}
        label="Next Snapshot"
      >
        <IconButton
          aria-label="Next Snapshot"
          icon={<IconChevronRightFill />}
          onPress={nextPage}
          variant="text"
        />
      </KeyBind>
    </div>
  );
};

export default DiffHeaderNav;
